import Model from '../utils/Model'

export default class WarnRuleConstants {
  constructor(code, englishName, chineseName, dataType, lob) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
    this.dataType = dataType
    this.lob = lob
  }
}

/**
 * 预警条件
 * @type {WarnRuleConstants}
 */
export const ALERT_TYPE_ETD = new WarnRuleConstants(0, 'ETD', '开航时间（ETD）', 'SE-1-0', 'SE')
export const ALERT_TYPE_ETA = new WarnRuleConstants(1, 'ETA', '到港时间（ETA）', '1-1', 'SE')
export const ALERT_TYPE_TOD = new WarnRuleConstants(2, 'Terminal Open Date', '开港时间', '1-2', 'SE')
export const ALERT_TYPE_TCO = new WarnRuleConstants(3, 'Terminal Cut Off', '截港时间', '1-3', 'SE')
export const ALERT_TYPE_FCO = new WarnRuleConstants(4, 'File Cut Off', '截单时间', '1-4', 'SE')
export const ALERT_TYPE_BCCO = new WarnRuleConstants(5, 'barge Custom Cut off', '截关时间', '1-5', 'SE')
export const ALERT_TYPE_BERTHING = new WarnRuleConstants(6, 'Est. Berthing', '计划靠泊日期', '1-6', 'SE')
export const ALERT_TYPE_LEAVING_BERTH = new WarnRuleConstants(7, 'Est. Leaving Berth', '计划离泊日期', '1-7', 'SE')

export const ALERT_TYPES = new Set([ALERT_TYPE_ETD, ALERT_TYPE_ETA, ALERT_TYPE_TOD, ALERT_TYPE_TCO,
  ALERT_TYPE_FCO, ALERT_TYPE_BCCO, ALERT_TYPE_BERTHING, ALERT_TYPE_LEAVING_BERTH])

export const REMIND_TYPE_DUMP_BOX = new WarnRuleConstants(1, 'Early warning of possible box dumping', '可能甩箱预警', '2-1', 'SE')
export const REMIND_TYPE_SEA_RELEASE = new WarnRuleConstants(2, 'Early warning of non release of sea release', '海放未放行预警', '2-2', 'SE')
export const REMIND_TYPE_STACKING_RELEASED = new WarnRuleConstants(3, 'Pre warning of stacking not released', '码放未放行预警', '2-3', 'SE')
export const REMIND_TYPE_STOWAGE = new WarnRuleConstants(4, 'Reminder not configured for stowage', '配载未配置提醒', '2-4', 'SE')
export const REMIND_TYPE_CONTAINER = new WarnRuleConstants(5, 'Update reminder of container cargo information data in port area', '港区箱货信息数据更新提醒', '2-5', 'SE')

export const REMIND_TYPES = new Set([REMIND_TYPE_DUMP_BOX, REMIND_TYPE_SEA_RELEASE, REMIND_TYPE_STACKING_RELEASED, REMIND_TYPE_STOWAGE,
  REMIND_TYPE_CONTAINER])

/**
 * 预警提醒合集
 * @type {Set<*>}
 */
export const ALERT_AND_REMIND_TYPES = new Set([...ALERT_TYPES, ...REMIND_TYPES])

export const WARN_STATE_PENDING = new WarnRuleConstants(0, 'Pending', '待处理')
export const WARN_STATE_IGNORED = new WarnRuleConstants(1, 'Ignored', '已忽略')
export const WARN_STATE_PROCESSED = new WarnRuleConstants(2, 'Processed', '已处理')

export const WARN_STATES = [WARN_STATE_PENDING, WARN_STATE_IGNORED, WARN_STATE_PROCESSED]
/**
 *  return null:没找到.
 */
export function getAlertTypeByCode(code) {
  return Model.getObjByCode(code, ALERT_TYPES)
}
